'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    width: 56px; // 64px - 3px border on two sides\n    height: 56px;\n    opacity: 0;\n  }\n'], ['\n  0% {\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    width: 56px; // 64px - 3px border on two sides\n    height: 56px;\n    opacity: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  border: 4px solid currentColor;\n  opacity: 1;\n  border-radius: 50%;\n  transform-origin: center;\n  animation: ', ' 0.975s ease-out infinite;\n'], ['\n  position: absolute;\n  border: 4px solid currentColor;\n  opacity: 1;\n  border-radius: 50%;\n  transform-origin: center;\n  animation: ', ' 0.975s ease-out infinite;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var animation = (0, _styledComponents.keyframes)(_templateObject);

var Base = (0, _styledComponents2.default)(_Box2.default)(_templateObject2);
var Inner = (0, _styledComponents2.default)(_Box2.default)(_templateObject3, animation);

var Loading = function Loading(props) {
  return _react2.default.createElement(
    Base,
    _extends({ role: 'presentation', 'aria-label': 'Loading' }, props),
    _react2.default.createElement(Inner, null),
    _react2.default.createElement(Inner, null)
  );
};

Loading.defaultProps = {
  theme: _theme2.default,
  color: 'primary'
};

exports.default = Loading;